import ReactGA from "react-ga4";
let Utility = {};

/*
function clamp(x, a, b) {
	if (x < a) {
		return a;
	} else if (x > b) {
		return b;
	} else {
		return x;
	}
};
*/

function bind(fn, ctx) {
	if (ctx) {
		return function() {
			return fn.call(ctx);
		};
	} else {
		return fn;
	}
};

/*

function defer(fn, ctx) {
	return delay(10, fn, ctx);
};
*/

Utility.logUserInteraction = (event_name, params = {}, details = {}) => {
	// console.log('processUserInteractionFromTrigger');
	// console.log(event_name);
	let options = {...params, ...details, video_title: document.title };
	// console.log(options);
	// Send out Google Analytics event
	ReactGA.event(event_name, options);

	// Send event to our system
	Utility.emit('player.statsevent', { event_name: event_name, ...options });
}

Utility.logUserInteractionNoGA = (event_name, params = {}, details = {}) => {
	let options = {...params, ...details, video_title: document.title };

	// Send event to our system
	Utility.emit('player.statsevent', { event_name: event_name, ...options });
}

Utility.delay = (ms, fn, ctx) => {
	return setTimeout(bind(fn, ctx), ms);
};

Utility.interval = (ms, fn, ctx) => {
	console.log('Setting interval');
	return setInterval(bind(fn, ctx), ms);
};

Utility.sec2hmsArray = (sec) => {
	let hr, mi, se;
	sec = Math.floor(sec);
	hr = parseInt(sec / (60 * 60), 10);
	mi = parseInt(sec / 60, 10) - hr * 60;
	se = sec % 60;

	return [hr, mi, se];
};

Utility.sec2hms = (sec) => {
	let result;
	result = Utility.sec2hmsArray(sec).join(':').replace(/\b\d\b/g, function(a) {
		if (+a === 0) {
			return '00';
		} else if (a < 10) {
			return '0' + a;
		} else {
			return a;
		}
	});

	return result.replace(/(^00:)|(^0)/, '');
};

/*

function sec2hmsTime(sec) {
	var result;
	result = sec2hmsArray(sec);
	return result[0] + "H" + result[1] + "M" + result[2] + "S";
};
*/

Utility.sec2hmsLong = (sec) => {
	var hr, hs, mi, ms, out, se, ss;
	[hr, mi, se] = Utility.sec2hmsArray(sec);
	// round up on half minutes
	mi += Math.floor(se / 30);
	out = [];
	if (hr > 0) {
		hs = hr !== 1 ? "s" : "";
		out.push(hr + " hour" + hs);
	}
	if (mi > 0) {
		ms = mi !== 1 ? "s" : "";
		out.push(mi + " minute" + ms);
	}
	if (se > 0) {
		ss = se !== 1 ? "s" : "";
		out.push(se + " second" + ss);
	}
	return out.join(" ");
};

/*
function normalizeWheelDelta(ev) {
	var delta;
	ev = ev.originalEvent || ev;
	delta = 0;
	if (ev.wheelDelta) {
		delta = ev.wheelDelta / 10;
	} else if (ev.detail) {
		delta = -ev.detail * 4;
	}
	return clamp(delta, -300, 300);
};
*/

/*
	Returns X & Y coordinate at which point the mouse was clicked, relative to the top left edge of the entire document.
	This includes any portion of the document not currently visible.
*/
Utility.getPage = (ev) => {
	ev = ev.originalEvent || ev;
	return {
		x: ev.pageX ? ev.pageX : (ev.touches && ev.touches[0].pageX),
		y: ev.pageY ? ev.pageY : (ev.touches && ev.touches[0].pageY)
	};
};

/*
	Shortcut to get the X position of the mouse click relative to the left edge of the entire document.
	This includes any portion of the document not currently visible.
*/
Utility.getPageX = (ev) => {
	return Utility.getPage(ev).x;
};

/*
	Shortcut to get the Y position of the mouse click relative to the top edge of the entire document.
	This includes any portion of the document not currently visible.
*/
Utility.getPageY = (ev) => {
	return Utility.getPage(ev).y;
};

/*
	Returns the top/left position of an HTML element relative to the top edge of the entire document.
*/
Utility.offset = (el) => {
	var rect = el.getBoundingClientRect(),
	scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
}

/*
	Returns the x/y offset of a mouse click relative to the top left edge of an HTML element
*/
Utility.getOffset = (ev, el) => {
	let page;
	el = el || window.document;
	page = Utility.getPage(ev);
	let offset = Utility.offset(el);
	return {
		x: page.x - offset.left,
		y: page.y - offset.top
	};
};

/*
	Shortcut to get the x/y offset of a mouse click relative to the left edge of an HTML element
*/
Utility.getOffsetX = (ev, el) => {
	return Utility.getOffset(ev, el).x;
};

/*
	Shortcut to get the x/y offset of a mouse click relative to the top edge of an HTML element
*/
Utility.getOffsetY = (ev, el) => {
	return Utility.getOffset(ev, el).y;
};

/*
	Returns relative offset of one element to another
*/
Utility.getElementRelativeOffset = (el1, el2)  => {
	var offset1 = Utility.offset(el1);
	var offset2 = Utility.offset(el2);

	return {
		x: offset1.left - offset2.left,
		y: offset1.top - offset2.top
	}
}

/*
	Returns relative X offset of one element to another
*/
Utility.getElementRelativeOffsetX = (el1, el2)  => {
	return Utility.getElementRelativeOffset(el1, el2).x;
}

/*
	Returns relative Y offset of one element to another
*/
Utility.getElementRelativeOffsetY = (el1, el2)  => {
	return Utility.getElementRelativeOffset(el1, el2).y;
}

Utility.getIndexofThingByTime = (time, things) => {
	var match = 0;

	for (var i = 0; i < things.length; i++) {
		if (time >= things[i][1]) {
			match = i;
		} else {
			break;
		}
	}

	return match;
}

Utility.getThingByTime = (time, things) => {
	var index = Utility.getIndexofThingByTime(time, things);

	return things[index];
}

Utility.getImageUrl = (baseImageUrl, prefix, filename) => {
	if (filename === null) {
		return null;
	}

	return baseImageUrl + '/' + filename;
}

/* General puprose event emitter */
Utility.emit = (event_name, message) => {
	document.dispatchEvent(new CustomEvent(event_name, { detail: message }));
}

Utility.call = (url, params, callback, method) => {
	var xhr = new XMLHttpRequest();

	// Setup our listener to process compeleted requests
	xhr.onreadystatechange = () => {
		// Only run if the request is complete
		if (xhr.readyState !== 4) return;
		callback(xhr);
	}

	// When running locally, choose leccap-beta.engin for our domain
	if (window.location.href.includes('localhost')) {
		url = '//leccap-beta.engin.umich.edu' + url;
	} else if (window.location.href.includes('3000')) {
		url = '//' + window.location.hostname + url;
	}

	// If running the player in leccap_api, keep it there
	if (window.location.href.includes('leccap_api')) {
		url = url.replace('/leccap/', '/leccap_api/');
	}

	if (method === 'POST') {
		xhr.open('POST', url, true);

		// API takes JSON, checkins take form-urlencoded
		if (url.indexOf('player/api') > 0) {
			// Need to use text/plain (not application/json) otherwise XHR fails due to CORS
			xhr.setRequestHeader('Content-Type', 'text/plain');
			xhr.send(JSON.stringify(params));
		} else {
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.send(Utility.toUrlEncoded(params));
		}
	}

	if (method === 'GET') {
		xhr.open('GET', url);
		xhr.send();
	}
}

Utility.callPost = (url, params, callback) => {
	Utility.call(url, params, callback, 'POST');
}

Utility.callGet = (url, callback) => {
	Utility.call(url, null, callback, 'GET');
}

Utility.callApi = (path, params, callback, method) => {
	var recording_key = '',
		location = window.location.href,
		segments = location.split('/');

	for (var i = segments.length - 1; i >= 0; i--) {
		recording_key = segments[i];

		if (recording_key !== '') {
			i = -1;
		}
	}

	var url = '/leccap/player/api/' + path + '/?rk=' + recording_key.replace('?', '&');

	Utility.call(url, params, callback, method);
}

Utility.callApiPost = (path, params, callback) => {
	Utility.callApi(path, params, callback, 'POST');
}

Utility.callApiGet = (path, callback) => {
	Utility.callApi(path, null, callback, 'GET');
}

Utility.toUrlEncoded = (obj) => {
	return Object.keys(obj).map((k) => {
		return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
	}).join('&');
}

// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
Utility.storageAvailable = (type) => {
	try {
		var storage = window[type],
				x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	}
	catch(e) {
		return e instanceof DOMException && (
				// everything except Firefox
				e.code === 22 ||
				// Firefox
				e.code === 1014 ||
				// test name field too, because code might not be present
				// everything except Firefox
				e.name === 'QuotaExceededError' ||
				// Firefox
				e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
				// acknowledge QuotaExceededError only if there's something already stored
				storage.length !== 0;
	}
};

Utility.localStorageGet = (key) => {
	if (Utility.storageAvailable('localStorage')) {
		key = 'CAEN_VIEWER_#1.0.0:' + key;

		return localStorage.getItem(key);
	}

	return false;
};

Utility.localStorageRemove = (key) => {
	if (Utility.storageAvailable('localStorage')) {
		key = 'CAEN_VIEWER_#1.0.0:' + key;
		localStorage.removeItem(key + '.expiry');
		localStorage.removeItem(key);
	}

	return true;
};

Utility.localStorageSet = (key, val, expires) => {
	if (Utility.storageAvailable('localStorage')) {
		key = 'CAEN_VIEWER_#1.0.0:' + key;

		if (expires === true) {
			// Expire lines three days later
			var date = new Date(),
				expires_in = 3 * 24 * 60 * 60,
				expires_after = Math.round((date.setSeconds(date.getSeconds()+expires_in))/1000);

		    localStorage.setItem(key + '.expiry', expires_after);
		}

		return localStorage.setItem(key, val);
	}

	return false;
};

Utility.localStorageClean = () => {
	if (Utility.storageAvailable('localStorage')) {
		console.log('Cleaning!');

	}
};


Utility.isPromise = (promi) => {
	return !!promi && (typeof promi === 'object' || typeof promi === 'function') && typeof promi.then === 'function';
};

Utility.checksum = function(text) {
	var hash = 0,
		strlen = text.length,
		i,
		c;

	if ( strlen === 0 ) {
		return hash;
	}

	for (i = 0; i < strlen; i++) {
		c = text.charCodeAt(i);
		hash = ((hash << 5) - hash) + c;
		hash = hash & hash; // Convert to 32bit integer
	}

	return hash;
};

export default Utility;